import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { setCurrent } from '../store/autoBroadcastsSlice';
import { AutoBroadcastProps } from '../service/autoBroadcast.interface';
import { useAppDispatch } from '../../../../../store';

const { Link } = Typography;

export const AutoBroadcastViewButton = ({
    data,
}: {
    data: AutoBroadcastProps;
}) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return (
        <Link
            onClick={() => {
                navigate(`${data.id}`);
                dispatch(setCurrent(data));
            }}
        >
            Подробнее
        </Link>
    );
};
